import { ContentCard } from "@msuite/ui/content-card";
import { Divider } from "@msuite/ui/divider";
import { TextInput } from "@msuite/ui/form";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { CalculationFormSchema } from "@msuite/utils/schemas";
import { useFormContext, useWatch } from "react-hook-form";
import { ContactPicker } from "@/components/contacts";
import { AddressForm } from "../address-form";

export function CalculationFormMetaData() {
	/** Hooks */
	const methods = useFormContext<CalculationFormSchema>();
	const { t } = useTranslation();
	const [streetName, houseNumber] = useWatch({
		control: methods.control,
		name: ["streetName", "houseNumber"],
	});

	/** Render */
	return (
		<div className="h-full overflow-y-auto">
			<ContentCard
				title={t("calculations.meta_data")}
				icon={icon("Info")}
				variant="plain"
			>
				<div className="flex flex-col gap-6">
					<TextInput
						control={methods.control}
						name="offerNumber"
						label={t("calculations.offer_number")}
						placeholder="2026-001"
						isRequired={false}
					/>
					<TextInput
						control={methods.control}
						name="projectName"
						label={t("calculations.project_name")}
						placeholder={`${streetName ?? ""} ${houseNumber ?? ""}`.trim() || "Schillerstraße 3"}
						isRequired={false}
					/>
					<ContactPicker
						control={methods.control}
						name="clientId"
						label={t("projects.fields.client")}
					/>
					<Divider variant="modal" />
					<AddressForm />
				</div>
			</ContentCard>
		</div>
	);
}
